import * as React from 'react';
import tombacIcon from '../tombacIcon';

function SvgRectangle(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="4 0 16 24" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M18 4a2 2 0 011.001 3.732v8.536a2 2 0 11-2.733 2.733H7.732A2 2 0 115 16.268V7.732A2 2 0 117.732 5h8.536c.345-.598.992-1 1.732-1zm-1.732 3.001H7.732a2.012 2.012 0 01-.73.73v8.537c.302.176.555.429.73.732h8.536c.175-.304.428-.557.732-.732V7.732a2.017 2.017 0 01-.732-.73z"
      />
    </svg>
  );
}

export default tombacIcon('Rectangle')(SvgRectangle);
